import React from 'react';

const Navbar = ({scroll, mostrarmenu, setMostrarMenu}) => {
	const handleMenuMobile = () => {
		setMostrarMenu((state) => !state);
	};

	return (
		<>
			<div className={`navbar ${scroll ? 'navbar--scroll' : ''} ${mostrarmenu ? 'navbar--menu' : ''}`}>
				<div className='navbar__container'>
					<a href='#banner' className='navbar__logo'>
						<img src='./img/logo.svg' alt='logo corso cnc' width='50' />
					</a>
					<nav className='navbar__nav'>
						<a href='#about' className='navbar__nav-link'>
							Nosotros
						</a>
						<a href='#benefits' className='navbar__nav-link'>
							Beneficios
						</a>
						<a href='#galery' className='navbar__nav-link'>
							Galeria
						</a>
						<a href='#products' className='navbar__nav-link'>
							Productos
						</a>
					</nav>
					<div className='navbar__btn' onClick={handleMenuMobile}>
						<svg width='30' height='25' viewBox='0 0 57 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
							<path
								d='M56.25 0H0.568182C0.255682 0 0 0.255682 0 0.568182V5.11364C0 5.42614 0.255682 5.68182 0.568182 5.68182H56.25C56.5625 5.68182 56.8182 5.42614 56.8182 5.11364V0.568182C56.8182 0.255682 56.5625 0 56.25 0ZM56.25 44.3182H0.568182C0.255682 44.3182 0 44.5739 0 44.8864V49.4318C0 49.7443 0.255682 50 0.568182 50H56.25C56.5625 50 56.8182 49.7443 56.8182 49.4318V44.8864C56.8182 44.5739 56.5625 44.3182 56.25 44.3182ZM56.25 22.1591H0.568182C0.255682 22.1591 0 22.4148 0 22.7273V27.2727C0 27.5852 0.255682 27.8409 0.568182 27.8409H56.25C56.5625 27.8409 56.8182 27.5852 56.8182 27.2727V22.7273C56.8182 22.4148 56.5625 22.1591 56.25 22.1591Z'
								fill='white'
							/>
						</svg>
					</div>
				</div>
			</div>
		</>
	);
};

export default Navbar;
